<template>
  <v-btn fab x-small :to="{ name: 'rewards' }" color="var(--v-secondary-base)">
    <img src="@/assets/views/crown_rewards_white.svg" :height="16" />
  </v-btn>
</template>

<script>
export default {
  name: "XsRewardsButton",
  data() {
    return {
      includeLoyalty:
        process.env.VUE_APP_INCLUDE_LOYALTY.toLowerCase() === "true",
    };
  },
};
</script>
